import { GetterTree } from 'vuex'
import TagsState from "../../types/TagsState";
import RootState from '@vue-storefront/core/types/RootState'

const getters: GetterTree<TagsState, RootState> = {
  isTagActive: state => tag => state.selected_tags.find(sTag => sTag.code === tag.code),
  getTags: state => state.tags,
  getSelectedTags: state => state.selected_tags,
  getLoadedFor: state => state.loadedFor
}

export default getters
